import { z } from 'zod'

/**
 * What a company does with an ad account it can reach. Mirrors `AdAccountUse` in
 * the Prisma schema (docs/ad-analytics.spec.md, "Ad accounts").
 *
 * - `not_in_use` — found, and waiting for an admin. Nothing is imported.
 * - `ignored` — set aside, such as another client's account under the same
 *   manager account. Nothing is imported.
 * - `in_use` — pointed at a venue, and updating.
 * - `stopped` — still pointed at its venue with its numbers kept, but not
 *   updating.
 */
export const AD_ACCOUNT_USES = ['not_in_use', 'ignored', 'in_use', 'stopped'] as const

export const adAccountUseSchema = z.enum(AD_ACCOUNT_USES)

export type AdAccountUse = z.infer<typeof adAccountUseSchema>

/**
 * Pointed at a venue: updating, or stopped with its numbers kept. These are
 * the accounts whose numbers count.
 */
export const POINTED_AD_ACCOUNT_USES = ['in_use', 'stopped'] as const satisfies readonly AdAccountUse[]

/** Not pointed at a venue: waiting to be put in use, or set aside. */
export const UNPOINTED_AD_ACCOUNT_USES = ['not_in_use', 'ignored'] as const satisfies readonly AdAccountUse[]
